import { EventEmitter } from 'events'

/**
 * StickyHeader :
 *   ヘッダーのスティッキー
 */

class StickyHeader {
  constructor() {
    this.body = document.querySelector('body')
    this.scroll = 0
    this.staticName = '-staticNav'
    this.fixedName = '-fixedNav'
    this.hiddenName = '-hiddenNav'
    this.isEnable = true
  }

  init() {
    setTimeout(() => {
      this.attachEvent()
    }, 300)
  }

  attachEvent() {
    window.addEventListener('scroll', this.onScorll.bind(this))
  }

  onScorll() {
    const isMenuOpen = this.body.classList.contains('-menuOpen')

    if (!this.isEnable) {
      return false
    }

    if (window.pageYOffset === 0) {
      this.body.classList.remove(this.fixedName)
      this.body.classList.remove(this.hiddenName)
      this.body.classList.add(this.staticName)
      return
    } else if (window.pageYOffset > 200) {
      this.body.classList.add(this.hiddenName)
      this.body.classList.remove(this.staticName)

      if (this.scroll > window.pageYOffset) {
        this.body.classList.remove(this.hiddenName)
        this.body.classList.add(this.fixedName)
      }
    }

    this.scroll = window.pageYOffset
  }

  hiddenNav() {
    this.body.classList.add(this.hiddenName)
  }

  deactivate() {
    this.isEnable = false;
  }

  activate() {
    this.isEnable = true;
  }
}

export default StickyHeader



// WEBPACK FOOTER //
// ./src/script/modules/StickyHeader.js